import React, { CSSProperties, forwardRef } from "react";

import Tooltip from "antd/es/tooltip";
import cn from "classnames";

import { formatRawDate, formatRawDateRelative } from "@app/util/formatters";

import styles from "./BaseEvent.module.scss";

export interface DateStartEventProps {
  date: string;
  style?: CSSProperties;
}

const DateStartEvent = forwardRef<HTMLDivElement, DateStartEventProps>(({ date, style }, ref) => {
  return (
    <div className={styles.outerContainer} ref={ref} style={style}>
      <div className={cn(styles.tail, styles.dateEventTail)} />
      <div className={styles.head}>
        <div className={styles.dot} />
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={cn(styles.title, styles.dateTitle)}>
            <Tooltip title={formatRawDate(date, "PPPP")}>
              {formatRawDateRelative(date, Date.now())}
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
});

export default DateStartEvent;
